import { css } from '@bts-web/utils-style-engine';
import {
  ListCellsSelectionItem as DesignListCellsSelectionItem,
  ListCellsSelectionItemProps,
} from '@bts-web/design-system/component/list-cells-selection';
import { ListCellsSelectionItemBadge } from './ListCellsSelectionItemBadge';
import { ListCellsSelectionIndicator } from './ListCellsSelectionIndicator';
import { ListCellsSelectionItemContainer } from './ListCellsSelectionItemContainer';

type ListCellsSelectionCheckmarkItemProps = Omit<
  ListCellsSelectionItemProps,
  'value'
> & {
  activeItemId?: string;
  value?: string;
  badge?: string;
  label: string;
  subLabel?: string;
  separator?: boolean;
  isDisabled?: boolean;
  icon?: React.ReactElement;
};

const displayFlexWithCenteredItems = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ListCellsSelectionCheckmarkItem = ({
  activeItemId = '',
  id,
  badge,
  label,
  subLabel,
  value = '',
  isDisabled = false,
  separator = true,
  icon,
  ...rest
}: ListCellsSelectionCheckmarkItemProps) => {
  return (
    <ListCellsSelectionItemContainer
      activeItemId={activeItemId}
      label={label}
      subLabel={subLabel}
      itemId={id}
      isDisabled={isDisabled}
      hasBorder={false}
      separator={separator}
      icon={icon}
      {...(badge && {
        icon: (
          <ListCellsSelectionItemBadge
            value={badge}
            visual={activeItemId === id ? 'active' : 'default'}
          />
        ),
      })}
    >
      <DesignListCellsSelectionItem
        {...rest}
        className={css({
          ...displayFlexWithCenteredItems,
          width: '24px',
          height: '24px',
        })}
        disabled={isDisabled}
        id={id}
        value={value}
      >
        <ListCellsSelectionIndicator visual="checkmark" />
      </DesignListCellsSelectionItem>
    </ListCellsSelectionItemContainer>
  );
};

export { ListCellsSelectionCheckmarkItem };
